export interface IBannerMultiloadCfgData {
    adqEnabled?: boolean;
    maxLatency?: string;
    heartbeatDelay?: string;
    concurrency?: string;
    url?: string;
    adfTransportUrl?: string;
}

export const DEFAULT_CONCURRENCY = 9999;

const defaultData: IBannerMultiloadCfgData = {
    adqEnabled: true,
    maxLatency: '500',
    heartbeatDelay: '150',
    concurrency: String(DEFAULT_CONCURRENCY),
    url: 'https://ad.mail.ru/adq/',
    adfTransportUrl: 'https://ad.mail.ru/adf/'
};

export class BannerMultiloadCfg {
    adqEnabled: boolean;
    maxLatency: number;
    heartbeatDelay: number;
    concurrency: number;
    url: string;
    adfTransportUrl: string;

    constructor(encoded: IBannerMultiloadCfgData) {
        encoded = {...defaultData, ...encoded};
        this.adqEnabled = encoded.adqEnabled || false;
        this.maxLatency = +encoded.maxLatency!;
        this.heartbeatDelay = +encoded.heartbeatDelay!;
        this.concurrency = +encoded.concurrency!;
        this.url = encoded.url!;
        this.adfTransportUrl = encoded.adfTransportUrl!;
    }
}
